/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdailyprizeswon3Inputs */

const en_dropdailyprizeswon3 = /** @type {(inputs: Dropdailyprizeswon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Won`)
};

const de_dropdailyprizeswon3 = /** @type {(inputs: Dropdailyprizeswon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewonnen`)
};

/**
* | output |
* | --- |
* | "Won" |
*
* @param {Dropdailyprizeswon3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdailyprizeswon3 = /** @type {((inputs?: Dropdailyprizeswon3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdailyprizeswon3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdailyprizeswon3(inputs)
	return de_dropdailyprizeswon3(inputs)
});
export { dropdailyprizeswon3 as "dropDailyPrizesWon" }